var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-dialog',{attrs:{"max-width":_vm.getSize,"persistent":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }